import React from 'react';
import UserAnnouncements from '../../components/user/Ads/UserAnnouncements';

export const UserAnnouncementsPage = () => {

    return (
        <UserAnnouncements />
    )
}